module.exports = __webpack_public_path__ + "media/deal-card.91eac603.mp4";